export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/worker.763e2f70.worker.js");
}
